import * as React from 'react';
import { Element } from 'react-scroll';
import * as styles from './Header.css';
import { Nav } from './Nav';

export const HEADER_REF = 'header';

export class Header extends React.Component {
    render() {
        return (
            <Element name={HEADER_REF} className={styles.container}>
                <div className={styles.blurb}>
                    <h1>
                        Hello World! I’m Christina (:
                    </h1>
                    <p>
                        I’m a hackathon addict, an avid presenter, a tech enthusiast,
                    and am obsessed with side projects.
                    </p>
                    <p> I love inventing useful apps to solve problems that real people face </p>
                </div>
                <div className={styles.title}>
                    <span>Christina Kayastha</span>
                    <span>Senior Software Engineer</span>
                    <span>Hacker | Maker | Builder</span>
                </div>
                <div className={styles.picture}>
                    <div className={styles.photo}>
                        <img src={`${process.env.PUBLIC_URL}/ck4.png`} alt="photo" />
                        <img src={`${process.env.PUBLIC_URL}/ck3.png`} alt="photo" />
                        <img src={`${process.env.PUBLIC_URL}/ck2.png`} alt="photo" />
                        <img src={`${process.env.PUBLIC_URL}/ck1.png`} alt="photo" />
                    </div>
                </div>
                <div className={styles.nav}>
                    <Nav />
                </div>
            </Element>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Header.tsx